var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
export default React.memo(function (props) {
    return (React.createElement("svg", __assign({ width: 48, height: 48, viewBox: "0 0 48 48", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("defs", null,
            React.createElement("clipPath", { id: "notice_svg__a" },
                React.createElement("path", { d: "M9.037 23a3.001 3.001 0 005.658 0H9.037zm2.83-18a7 7 0 00-7 7v5.256l-.123.224c-.414.757-1.162 1.563-2.244 2.45l-.098.083c-.681.602-.51.987.464.987h18c1.043 0 1.175-.385.354-1.08l-.266-.23c-.947-.828-1.598-1.552-1.961-2.203l-.127-.227V12a7 7 0 00-7-7zm0-3a2 2 0 00-1.828 1.185 9.05 9.05 0 011.562-.181L11.866 3a9.04 9.04 0 011.826.185A1.997 1.997 0 0011.866 2zm0 25a5.002 5.002 0 01-4.9-4h-4.1c-2.928 0-3.859-2.795-1.635-4.617l.243-.203c.624-.532 1.075-1.004 1.353-1.402l.037-.058.001-4.72a9 9 0 015.002-8.065L7.866 4a4 4 0 018-.065 9 9 0 015 8.065v4.712l.115.16c.284.37.727.823 1.324 1.343l.208.178C24.735 20.275 23.799 23 20.866 23h-4.1a5.002 5.002 0 01-4.9 4z" }))),
        React.createElement("g", { clipPath: "url(#notice_svg__a)", transform: "translate(12.134 10)" },
            React.createElement("path", { fill: "currentColor", d: "M0 0h23.742v27H0V0z" }))));
});
